<div class="modal-header justify-content-center border-0 pb-0">
    <h4 class="modal-title text-primary text-center" id="modal-basic-title">{{'CLAIM_FOR_ORDER_NUMBER' | translate}} {{order.id}}
    </h4>
</div>

<div class="modal-body py-2">
    <p class="text-center mb-3" translate>OTTO_OLSEN_CLAIM_MODAL_DESCRIPTION</p>
    <div class="d-flex justify-content-center gap-2">
        <button class="btn btn-primary" (click)="fullOrderClaim()" translate>OTTO_OLSEN_FULL_ORDER</button>
        <button class="btn btn-primary" (click)="partialOrderClaim()" translate>OTTO_OLSEN_PARTIAL_ORDER</button>
    </div>
</div>

<div class="modal-footer justify-content-center border-0 pt-0">
    <button class="btn btn-outline-primary" (click)="cancel()" translate>CANCEL</button>
</div>